import type { MagentoApiSetShippingMethodsOnCartMutationResponse } from "@jti/magento-api-v2";
import { MagentoGraphQLRequestClientError } from "@jti/magento-api-v2";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

type SetShippingMethodsOnCartPayload = {
  cartId: string;
  carrierCode: string;
  methodCode: string;
};

export const setShippingMethodsOnCartEndpoint = (builder: MagentoApiBuilder) => ({
  setShippingMethodsOnCart: builder.mutation<
    MagentoApiSetShippingMethodsOnCartMutationResponse,
    SetShippingMethodsOnCartPayload
  >({
    query: ({ cartId, carrierCode, methodCode }) => ({
      method: "setShippingMethodsOnCart",
      params: [{ cartId, carrierCode, methodCode }],
    }),
    transformErrorResponse: (error) => {
      if (!MagentoGraphQLRequestClientError.isMagentoGraphQLRequestClientError(error)) {
        return error;
      }

      const errorsDetails = error.errorsDetails;
      error.message = errorsDetails ? errorsDetails[0].message : error.message;
      return {
        ...error,
        message: errorsDetails ? errorsDetails[0].message : error.message,
      };
    },
    invalidatesTags: [TAGS.CART_ORDER_PRICES, TAGS.SHIPPING_METHODS, TAGS.AVAILABLE_PAYMENT_METHODS],
  }),
});
